import React from "react";
import { Link } from "react-router-dom";
import ProjectsShadowStage from "./Projects/ProjectsShadowStage";
import { ProjectsShadowWrap } from "./Projects/styles";

export default function ThreeDemo() {
  return (
    <div className="flex-grow-1 bg-black text-white pt-4 pb-5">
      <div className="container px-3 px-lg-4">
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
          <div>
            <p className="text-secondary text-uppercase small mb-1 letter-spacing-1">
              Interactive 3D
            </p>
            <h1 className="h4 mb-0 text-white fw-semibold">
              Shadow map demo
            </h1>
          </div>
          <Link to="/" className="btn btn-outline-light btn-sm">
            ← Home
          </Link>
        </div>
        <ProjectsShadowWrap className="animate__animated animate__fadeIn">
          <ProjectsShadowStage variant="standalone" />
          <p className="text-center text-secondary small mt-3 mb-0 px-2">
            Directional + spot lights with PCF soft shadows and helpers (orbit:
            drag / pinch). Same scene as on the home page, larger canvas.
          </p>
        </ProjectsShadowWrap>
      </div>
    </div>
  );
}
